import { Observable } from 'rxjs';
import {
  ApiService,
  CANCEL_HOSTED_GAME_PATH,
  CancelHostedGamePathParams,
  CREATE_HOSTED_GAME_PATH,
  CREATE_PLACEHOLDER_PLAYER_PATH,
  CreateHostedGameBody,
  CreateHostedGameResponse,
  CreatePlaceholderPlayerBody,
  CreatePlaceholderPlayerPathParams,
  GENERATE_REASSIGN_TOKEN_PATH,
  GenerateReassignTokenPathParams,
  GenerateReassignTokenResponse,
  GET_HOSTED_GAME_PATH,
  GetHostedGamePathParams,
  GetHostedGameResponse,
  HostRemovalReason,
  MARK_GAME_PLAYER_AS_NOT_PAID_PATH,
  MARK_GAME_PLAYER_AS_PAID_PATH,
  MarkGamePlayerAsNotPaidPathParams,
  MarkGamePlayerAsPaidPathParams,
  REASSIGN_GAME_BY_TOKEN_PATH,
  ReassignGameByTokenPathParams,
  REMOVE_GAME_PLAYER_PATH,
  RemoveGamePlayerDto,
  RemoveGamePlayerPathParams,
  UPDATE_HOSTED_GAME_PATH,
  UPDATE_PLACEHOLDER_PLAYER_PATH,
  UpdateHostedGameBody,
  UpdateHostedGamePathParams,
  UpdateHostedGameResponse,
  UpdatePlaceholderPlayerBody,
  UpdatePlaceholderPlayerPathParams
} from '@core-http';

export class HostedGamesService extends ApiService {
  createGame(payload: CreateHostedGameBody): Observable<CreateHostedGameResponse> {
    return this.httpClient.post<CreateHostedGameResponse>(`${this.env.apiUrl}${CREATE_HOSTED_GAME_PATH}`, payload);
  }

  updateGame(
    pathParams: UpdateHostedGamePathParams,
    payload: Partial<UpdateHostedGameBody>
  ): Observable<UpdateHostedGameResponse> {
    const path: string = this.fillPathParams(UPDATE_HOSTED_GAME_PATH, pathParams);

    return this.httpClient.patch<UpdateHostedGameResponse>(`${this.env.apiUrl}${path}`, payload);
  }

  getOneGame(pathParams: GetHostedGamePathParams): Observable<GetHostedGameResponse> {
    const path: string = this.fillPathParams(GET_HOSTED_GAME_PATH, pathParams);

    return this.httpClient.get<GetHostedGameResponse>(`${this.env.apiUrl}${path}`);
  }

  removeGame(pathParams: CancelHostedGamePathParams): Observable<void> {
    const path: string = this.fillPathParams(CANCEL_HOSTED_GAME_PATH, pathParams);

    return this.httpClient.delete<void>(`${this.env.apiUrl}${path}`);
  }

  removePlayer(pathParams: RemoveGamePlayerPathParams, removalReason?: HostRemovalReason): Observable<void> {
    const path: string = this.fillPathParams(REMOVE_GAME_PLAYER_PATH, pathParams);
    const body: RemoveGamePlayerDto = { removalReason };

    return this.httpClient.delete<void>(`${this.env.apiUrl}${path}`, { body });
  }

  markAsPaid(pathParams: MarkGamePlayerAsPaidPathParams): Observable<void> {
    const path: string = this.fillPathParams(MARK_GAME_PLAYER_AS_PAID_PATH, pathParams);

    return this.httpClient.post<void>(`${this.env.apiUrl}${path}`, null);
  }

  markAsNotPaid(pathParams: MarkGamePlayerAsNotPaidPathParams): Observable<void> {
    const path: string = this.fillPathParams(MARK_GAME_PLAYER_AS_NOT_PAID_PATH, pathParams);

    return this.httpClient.post<void>(`${this.env.apiUrl}${path}`, null);
  }

  addPlayer(pathParams: CreatePlaceholderPlayerPathParams, payload: CreatePlaceholderPlayerBody): Observable<void> {
    const path: string = this.fillPathParams(CREATE_PLACEHOLDER_PLAYER_PATH, pathParams);

    return this.httpClient.post<void>(`${this.env.apiUrl}${path}`, payload);
  }

  editPlayer(pathParams: UpdatePlaceholderPlayerPathParams, payload: UpdatePlaceholderPlayerBody): Observable<void> {
    const path: string = this.fillPathParams(UPDATE_PLACEHOLDER_PLAYER_PATH, pathParams);

    return this.httpClient.put<void>(`${this.env.apiUrl}${path}`, payload);
  }

  reassignGame(pathParams: ReassignGameByTokenPathParams): Observable<void> {
    const path: string = this.fillPathParams(REASSIGN_GAME_BY_TOKEN_PATH, pathParams);

    return this.httpClient.post<void>(`${this.env.apiUrl}${path}`, null);
  }

  generateReassignUrl(pathParams: GenerateReassignTokenPathParams): Observable<GenerateReassignTokenResponse> {
    const path: string = this.fillPathParams(GENERATE_REASSIGN_TOKEN_PATH, pathParams);

    return this.httpClient.post<GenerateReassignTokenResponse>(`${this.env.apiUrl}${path}`, null);
  }
}
